<template>
  <div class="keyVisualWrapper" :style="cssVars">
    <div>
      <video autoplay :style="styles" :controls="controls" loop muted controlslist="nodownload" class="video">

        <source :src="videoUrl"
                type="video/mp4">

        <!-- <source src="/media/cc0-videos/flower.mp4"
                type="video/mp4"> -->

        Sorry, your browser doesn't support embedded videos.
    </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "video-comp",
  props: {
    videoUrl: {
      type: String,
      required: true
    },
    styles:{
      type:Object,
      default:()=>{}
    },
    controls: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '100'
    },
    mobileWidth: {
      type: String,
      default: '100'
    }
  },
  computed: {
    cssVars () {
      return {
        '--max-width': this.width,
        '--max-mob-width': this.mobileWidth
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .keyVisualWrapper {
    /*need to change the MIME on S3 */
    /*background-image: url(https://jolt-assets.s3.eu-central-1.amazonaws.com/template/pampers_leafs.svg);*/
    background-repeat: no-repeat;
    position: relative;
  }

  .video {
    max-width: var(--max-width);
    @media (max-width: 767px) {
      max-width: var(--max-mob-width);
    }
  }

  .desktop_img {
    @media (max-width: 425px) {
      display: none;
    }
  }

  .mobile_img {
    @media (min-width: 425.9px) {
      display: none;
    }
  }

</style>
